module.exports = __webpack_public_path__ + "img/ph.7478a9ac.svg";